import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ERROR_ACTION, WAIT_FOR_ACTION } from 'redux-wait-for-action';
import { ConstantsUtil } from '@utils';
import { CLOSE_ALL_POPUPS, CLOSE_POPUP, CLOSING_POPUP_WITH_ANSWER, INIT_CLOSE_ALL_POPUPS, INIT_CLOSE_POPUP, INIT_POPUP_CLOSING_WITH_ANSWER, POPUP_INIT, SET_POPUP } from './popups.action-types';
export var actions = {
  /**
   * Init popup closing.
   *
   * @author Ihar Kazlouski
   * @function popupInitClosing
   * @category Actions
   * @subcategory Popups
   * @param {PopupClosePayload} payload payload.
   */
  popupInitClosing: function popupInitClosing(payload) {
    return {
      type: INIT_CLOSE_POPUP,
      payload: payload
    };
  },

  /**
   * Close popup.
   *
   * @author Ihar Kazlouski
   * @function popupClose
   * @category Actions
   * @subcategory Popups
   * @param {PopupClosePayload} payload payload.
   */
  popupClose: function popupClose(payload) {
    return {
      type: CLOSE_POPUP,
      payload: payload
    };
  },

  /**
   * Init close all popups.
   *
   * @author Ihar Kazlouski
   * @function popupInitCloseAll
   * @category Actions
   * @subcategory Popups
   */
  popupInitCloseAll: function popupInitCloseAll() {
    return {
      type: INIT_CLOSE_ALL_POPUPS
    };
  },

  /**
   * Close all popup.
   *
   * @author Ihar Kazlouski
   * @function popupCloseAll
   * @category Actions
   * @subcategory Popups
   * @param {PopupClosePayload} payload payload.
   */
  popupCloseAll: function popupCloseAll() {
    return {
      type: CLOSE_ALL_POPUPS
    };
  },

  /**
   * Init popup opening.
   *
   * @author Ihar Kazlouski
   * @function popupInit
   * @category Actions
   * @subcategory Popups
   * @param {PopupPayload} payload payload.
   */
  popupInit: function popupInit(payload) {
    var _ref;

    return _ref = {
      type: POPUP_INIT,
      payload: payload
    }, _defineProperty(_ref, WAIT_FOR_ACTION, "".concat(POPUP_INIT, "/").concat(ConstantsUtil.actions.ASYNC_SUCCESS)), _defineProperty(_ref, ERROR_ACTION, "".concat(POPUP_INIT, "/").concat(ConstantsUtil.actions.ASYNC_FAILED)), _ref;
  },

  /**
   * Set necessary popup.
   *
   * @author Ihar Kazlouski
   * @function setPopup
   * @category Actions
   * @subcategory Popups
   * @param {PopupPayload} payload payload.
   */
  setPopup: function setPopup(payload) {
    return {
      type: SET_POPUP,
      payload: payload
    };
  },

  /**
   * Init closing with answer.
   *
   * @author Ihar Kazlouski
   * @function popupInitClosingWithAnswer
   * @category Actions
   * @subcategory Popups
   * @param {PopupCloseWithAnswerPayload} payload payload.
   */
  popupInitClosingWithAnswer: function popupInitClosingWithAnswer(payload) {
    return {
      type: INIT_POPUP_CLOSING_WITH_ANSWER,
      payload: payload
    };
  },

  /**
   * Close popup with answer.
   *
   * @author Ihar Kazlouski
   * @function closeWithAnswer
   * @category Actions
   * @subcategory Popups
   * @param {PopupCloseWithAnswerPayload} payload payload.
   */
  closeWithAnswer: function closeWithAnswer(payload) {
    return {
      type: CLOSING_POPUP_WITH_ANSWER,
      payload: payload
    };
  }
};